
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from 'react-router-dom';
import Layout from "../layout"
import { loadDocs, selectDocsProject } from "../../redux/modules/docs"

const DocsProject = () => {    
    const dispatch = useDispatch();
    let { detail } = useParams();
    
    const auth = useSelector(state => state.auth);
    const docs = useSelector(state => state.docs);
    const project = useSelector(state => selectDocsProject(state, detail));
    
    useEffect(() => {
        document.title = 'Документы | Личный кабинет Брокера THE FIVE';
        if(!docs.loaded) {
            dispatch(
                loadDocs({
                    cmd: 'docs',
                    _debug_token: auth.token
                })
            )
        }
    }, [])

    console.log(docs)

    return (
        <Layout>
            <div class="breadcrumbs">
                <Link to="/docs">Назад к проектам</Link>
            </div>
            {project && (<>
                <div className="title">{project[0].name}</div>
                <div className="project-image">
                    <img src={project[0].img} alt="" />
                </div>
                <div className="project">
                    {
                        project[0].categories.map((item, i) => <Link to={`/docs/${project[0].link}/${item.link}`} className={`project__item fadeIn delay${i+1}00`} key={i}>{item.name}</Link>)
                    }                
                </div>
            </>)}            
        </Layout>
    )
}

export default DocsProject